import { InputLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';


export default function DropDown(props) {
  const [item, setItem] = React.useState("");


  const handleChange = (event) => {
    setItem(event?.target?.value);
    props.onChange(event)
  };
  useEffect(()=>{
    setItem("")
    setItem(props.periodicity?props.periodicity:"")
  },[props.periodicity])


  return (
    <div>
      <InputLabel className='__Input-label' id="label">{props.title}</InputLabel>
      <Select 
      defaultValue=""
      labelId="label" 
      id="select"  
      value={item}
      className='_InputBox'
      onChange={handleChange}>
       
      {
           props?.data && props?.data?.map(item=>{
             return(<MenuItem value={item}>{typeof item !=="string"?item?.criteria:item}</MenuItem>
           )
            })
          }
      </Select>
    </div>
  );
}

